import { Typography } from 'gu-ui-kit'
import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { ROUTES } from 'constants/routes'
import { useParams } from 'react-router-dom'
import { ACTIVATE } from 'modules/Auth/types'
import { useDispatch } from 'react-redux'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'

const Activation = () => {
  const { t } = useTranslation()
  const { token } = useParams()
  const history = useHistory()
  const dispatch = useDispatch()
  const pathGen = useGeneratePathI18n()

  useEffect(() => {
    if (!token?.length) {
      return
    }

    new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: ACTIVATE,
        payload: {
          data: { token },
        },
      })
    })
      .then(() => {
        history.push(pathGen(ROUTES.SERVICES))
      })
      .catch(() => {
        history.push(pathGen(ROUTES.AUTH_LOGIN))
      })
  }, [token, dispatch])

  return (
    <>
      <Helmet defer={false}>
        <title>{t('auth::activation.title')}</title>
      </Helmet>

      <Typography
        className={'margin-bottom-40'}
        component={'h1'}
        variant={'Body-Accent-40'}
        color={'Label-Fifth'}
      >
        {t('auth::activation.title')}
      </Typography>
    </>
  )
}

export default Activation
